import loadComponent from '../loadComponent';

loadComponent('play/PlayWrapper', 'play-picker');
